"use strict";
import Common from "./Common";
import GlitchFilter from "./GlitchFilter";

import SAT from "./SAT";

export default class SplashScene extends P3.Scene {
    constructor() {
        super();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._primaryHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._btnHolder = new PIXI.Container();

        /**
         * @type {P3.Button}
         * @private
         */
        this._playBtn = null;

        /**
         * @type {*|PIXI.Sprite}
         * @private
         */
        this._bg = P3.createSprite("splash_bg", this._primaryHolder);

        /**
         * @type {*|PIXI.Sprite}
         * @private
         */
        this._goggles = null;
    }

    init() {

        this._bg.anchor.set(0.5, 0);
        this._bg.x = Common.STAGE_WIDTH * 0.5;

        this.addChild(this._primaryHolder, this._btnHolder);

        this._playBtn = P3.simpleButton("big", "play", ()=> {
            this.end();
        }, this);

        this._playBtn.x = Common.STAGE_WIDTH * 0.5;
        this._playBtn.y = P3.View.height * 0.5 + 200;

        this._muteBtn = P3.simpleMute();
        this._muteBtn.y = 100;

        this._btnHolder.addChild(this._playBtn, this._muteBtn);

        this.trail = P3.createSprite("betty_trail", this._primaryHolder);
        this.trail.scale.set(0.75);
        this.trail.alpha = 0;


        this._spines = [];

        const betties = [];
        for (let i = 0; i < 3; i++) {
            let b = P3.createSpine("betty", "idle1");
            b.anchor = new PIXI.Point(0.5, 0.5);
            b.scale.set(0.25 + i * 0.15);
            b.backHolder = new PIXI.Container();
            b.backHolder.scale.set(0.25 + i * 0.06);

            b.emitter = P3.createParticles(b.backHolder, "part_virus_2", {
                name: "part_virus_",
                count: 3
            }, null, true);
            b.emitter.emit = true;

            this._primaryHolder.addChild(b.backHolder, b);
            betties.push(b);

            b.backHolder.visible = false;

            this._spines.push(b);

            if (i !== 1) {
                b.skeleton.setSkinByName("bad");
            } else {
                b.skeleton.setSkinByName("good");
                b.emitter.emit = false;
            }


        }

        var changeAnim = ()=> {
            for (let i = 0; i < this._spines.length; i++) {
                if (Math.random() < 0.5) {
                    this._spines[i].state.setAnimation(0, "idle1", true);
                }
            }
            delay(changeAnim, 5);
        };
        changeAnim();//lazy animation changer

        betties[0].x = 250;
        betties[0].y = 250;

        betties[1].x = Common.STAGE_WIDTH * 0.5 - 140;
        betties[1].y = P3.View.height * 0.5 + 75;

        betties[2].x = Common.STAGE_WIDTH * 0.5 + 375;
        betties[2].y = P3.View.height * 0.5 - 225;

        let b = P3.createSprite("betty_back_splash", this._primaryHolder);
        b.anchor.set(0.5);
        b.x = Common.STAGE_WIDTH * 0.5 - 15;
        b.y = P3.View.height * 0.5 - 35;
        betties.push(b);

        this.betties = betties;

        const logo = P3.createSprite("AT_logo_en", this._primaryHolder);
        logo.anchor.set(0.5);
        logo.x = Common.STAGE_WIDTH * 0.5;
        logo.y = 85;
        this.logo = logo;

        const title = P3.createSprite("game_title_" + Common.language, this._primaryHolder);
        title.anchor.set(0.5);
        title.x = Common.STAGE_WIDTH * 0.5;
        title.y = 225;
        this.title = title;

        const princess = P3.createSprite("princess", this._primaryHolder);
        princess.anchor.set(0.5, 1);
        princess.x = Common.STAGE_WIDTH * 0.5 + 225;
        princess.y = P3.View.height;
        this.princess = princess;

        const marc = P3.createSprite("marceline", this._primaryHolder);
        marc.anchor.set(0.5, 1);
        marc.x = Common.STAGE_WIDTH * 0.5 + 475;
        marc.y = P3.View.height;
        this.marc = marc;

        this.start();

        Common.renderer.backgroundColor = 0x0;

    }

    start() {
        Common.audio.stopMusic();
        Common.audio.playMusic("music_menu_loop_00");
    }

    appear() {

        Common.buttonsAppear([this._muteBtn, this._playBtn]);

        const t = 0.5;
        const title = this.title;

        const path = [
            {x: title.width * 0.5, y: title.y - 320},//start of curve
            {x: title.width * 0.5 + 125, y: title.y + 135},
            {x: title.x, y: title.y}
        ];

        const delay = 0.75;

        const logo = this.logo;
        TweenMax.from(title, t, {y: -250});
        TweenMax.from(logo, t, {y: -250});

        const marc = this.marc;
        marc.alpha = 0;
        TweenMax.to(marc, t, {alpha: 1, ease: Power0.easeNone, delay: delay + t + delay * 0.5});
        TweenMax.to(marc.scale, 2, {x: 1.01, y: 0.99, ease: Power1.easeInOut, yoyo: true, repeat: -1});

        const bArr = this.betties;
        for (let i = 0; i < bArr.length; i++) {
            if (i === 1) continue;
            let b = bArr[i];
            b.alpha = 0;

            let sR = -Math.PI * 0.025;
            let eR = Math.PI * 0.05;

            if (Math.random() < 0.5) sR = -sR;
            if (Math.random() < 0.5) eR = -eR;

            b.rotation = sR;

            TweenMax.to(b, t, {alpha: 1, ease: Power0.easeNone, delay: i * 0.1});
            TweenMax.to(b, 10 + 10 * Math.random(), {
                x: b.x + 25,
                y: b.y + 25,
                ease: Power1.easeInOut,
                delay: i * 0.1 + Math.random(),
                yoyo: true,
                repeat: -1,
                rotation: eR
            });

        }

        const p = this.princess;
        p.alpha = 0;
        TweenMax.to(p, t, {alpha: 1, ease: Power0.easeNone, delay: delay + t + delay * 0.75});
        TweenMax.to(p.scale, 2, {x: 1.01, y: 0.99, ease: Power1.easeInOut, yoyo: true, repeat: -1, delay: 0.1});

        const mainBetty = bArr[1];
        // mainBetty.position = path[0];
        mainBetty.backHolder.visible = false;
        for (let i = 0; i < this.betties.length; i++) {
            if (!this.betties[i].backHolder) continue;
            this.betties[i].backHolder.visible = true;
            this.betties[i].backHolder.alpha = 0;
            TweenMax.to(this.betties[i].backHolder, 2, {alpha: 1, ease: Power0.easeNone});
        }

        const mainBettyTime = 1;

        //define path
        const path2 = [
            {x: -Common.STAGE_WIDTH * 0.5 + 150, y: -150},
            {x: mainBetty.x - 100, y: mainBetty.y - 35},
            {x: mainBetty.x - 25, y: mainBetty.y - 125},
            {x: mainBetty.x, y: mainBetty.y}
        ];
        mainBetty.x = path2[0].x;
        mainBetty.y = path2[0].y;

        //tween along path
        TweenMax.to(mainBetty, mainBettyTime, {
            bezier: path2, ease: Power4.easeOut, delay: 0.5,
            onComplete: ()=> {
                mainBetty.backHolder.visible = true;
            }
        });

        const startScale = {x: mainBetty.scale.x, y: mainBetty.scale.y};
        mainBetty.scale.set(0);
        TweenMax.to(mainBetty.scale, mainBettyTime, {
            x: startScale.x,
            y: startScale.y,
            ease: Power4.easeOut,
            delay: 0.5,
            onComplete: ()=> {
                let trail = this.trail;
                // trail.scale.y = -trail.scale.y;
                trail.x = mainBetty.x - 150;
                trail.y = mainBetty.y - 200;

                TweenMax.to(trail, 2, {alpha: 0.35, ease: Power0.easeNone});

                let b = mainBetty;

                let sR = -Math.PI * 0.025;
                let eR = Math.PI * 0.05;

                if (Math.random() < 0.5) sR = -sR;
                if (Math.random() < 0.5) eR = -eR;

                TweenMax.to(b, t, {alpha: 1, ease: Power0.easeNone, delay: 0.1});
                TweenMax.to(b, 10 + 10 * Math.random(), {
                    x: b.x + 25,
                    y: b.y + 25,
                    ease: Power1.easeInOut,
                    delay: 0.1 + Math.random(),
                    yoyo: true,
                    repeat: -1,
                    rotation: eR
                });
            }
        });
    }

    end() {
        this._running = false;
        Common.audio.stopMusic();
        this.signals.next.dispatch(this);
    }

    update() {
        for (let i = 0; i < this._spines.length; i++) {
            this._spines[i].update(deltaTime);
        }

        for (let i = 0; i < this.betties.length; i++) {
            const b = this.betties[i];
            if (b.emitter) {//if betty has emitter update and set pos
                b.emitter.update(deltaTime * 0.5);
                b.backHolder.position.set(b.x, b.y);
            }
        }
    }

    destroy() {
        TweenMax.killAll();
        super.destroy({children: true});
    }

    resize() {
        this.x = (P3.View.width - Common.STAGE_WIDTH) * 0.5;
        this._muteBtn.x = (Common.STAGE_WIDTH + P3.View.width) * 0.5 - 100;
    }
}
